import { useRemoteResource } from "hooks/useRemoteResource";
import withRouter from "hoc/withRouter";
import { CircularProgress } from "@mui/material";
import ListPage from "components/ListPage/ListPage";
import tourScheduleService from "services/admin/tourScheduleService";
import { TourScheduleCard } from "components/TourScheduleCard/TourScheduleCard";


const TourScheduleList = () => {
    const [data, loadData, loading, error] = useRemoteResource(tourScheduleService.getAll, "");

    function buildContent() {
        if (error) {
            return <div>{error}</div>
        }
        if (loading) {
            return <div className="text-center"><CircularProgress></CircularProgress></div>
        }
        if (data.data.length === 0) {
            return <div>Расписание туров отсутсвуют. Чтобы добавить расписание для тура пожалуйста, нажмите на кнопку "Добавить" сверху</div>
        }
        if (data.data.length > 0) {
            return data.data.map(ts => {
                return <TourScheduleCard data={ts}></TourScheduleCard>
            })
        }
    }
    return (
        <ListPage pageTitle="Список расписании туров">
            <div className="m-t-32">
                {buildContent()}
            </div>
        </ListPage>

    );
};

export default withRouter(TourScheduleList);
